import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { TextField, VinTextField } from '@carsys/form'
import LicensePlateInputFormikField from '@carsys/form/src/LicensePlateInputFormikField'
import { CountriesDropdownFormik } from '@carsys/form/src/CountriesDropdownFormik'
import { useTicketFormContext } from '@cbgms/components/src/support-request/context/TicketFormContext'

export const VehicleFormFields = ({ preFilled }: { preFilled: boolean }) => {
  const { t } = useTranslation()
  const { clearVehicleValues, vehicleCountry, CountriesOptionsWrapper } = useTicketFormContext()

  // Clear Vehicle fields when these get unmounted
  useEffect(() => () => clearVehicleValues(), [])

  return (
    <Grid container direction='column' spacing={1.5}>
      <Grid item>
        <Typography variant='h5' gutterBottom>
          {t('Contact.VehicleInformation')}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container direction='row' spacing={1}>
          {!preFilled && (
            <Grid item xs={8}>
              <CountriesOptionsWrapper>
                {options => (
                  <CountriesDropdownFormik countryOptions={options} name='Vehicle.Country' label={t('vehicle.country')} required />
                )}
              </CountriesOptionsWrapper>
            </Grid>
          )}
          <Grid item xs={2}>
            <LicensePlateInputFormikField name='Vehicle.Registration' country={vehicleCountry} disabled={preFilled} size='large' required />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <VinTextField label={t('vehicle.vin')} disabled={preFilled} name='Vehicle.VIN' maxLength={17} />
      </Grid>
      <Grid item>
        <Grid container direction='row' spacing={1}>
          <Grid item xs={4}>
            <TextField label={t('vehicle.brand')} disabled={preFilled} name='Vehicle.Manufacturer' required />
          </Grid>
          <Grid item xs={4}>
            <TextField label={t('vehicle.model')} disabled={preFilled} name='Vehicle.Model' required />
          </Grid>
          <Grid item xs={4}>
            <TextField label={t('vehicle.type')} disabled={preFilled} name='Vehicle.Type' required />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
